import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import MenuItem from 'components/MenuItem'
import Select from 'components/Select'
import Typography from 'components/Typography'
import useViewport from 'hooks/useViewport'

import { toSentenceCase } from './helpers'

import classes from './SortSelect.module.scss'

const noop = () => {}
/** @type {import("./types").default} */
const SortSelect = ({
  id = '',
  onSelect = noop,
  selectedValue = '',
  showAboutSorting = false,
  type = 'search',
  values = [],
  testId,
  disabled = false,
  onClick,
}) => {
  const { is, down } = useViewport()

  const handleChange = inputValue => {
    const selectedItem = values.find(item => item.value.toString() === inputValue) || {}
    onSelect(selectedItem.label, inputValue)
  }

  return (
    <div className={clsx('SortSelect', classes.container)} data-testid={testId}>
      <div className={classes.formControl}>
        <Select
          labelid={`${type}-label`}
          data-testid={`${id}-dropdown`}
          value={selectedValue}
          onChange={handleChange}
          IconComponent={() => (
            <Icon
              className={classes.icon}
              icon={['fas', 'caret-down']}
              size={down('xs') ? '10' : '14'}
              data-testid="icon-fas-caret-down"
            />
          )}
          disabled={disabled}
          onClick={onClick}
        >
          {values.map(option => (
            <MenuItem key={`${option.label}-menu-item`} value={option.value}>
              <Typography className={classes.ellipsis} variant={is('xs') ? 'body-xs' : 'body-sm'}>
                {toSentenceCase(option.label)}
              </Typography>
            </MenuItem>
          ))}
          {showAboutSorting && (
            <MenuItem className={classes.menuItemAboutSorting} value="dialog">
              <Icon className={classes.iconInfo} prefix="far" icon="circle-info" size="16" />
              <Typography className={classes.ellipsis} variant={is('xs') ? 'body-xs' : 'body-sm'}>
                About sorting options
              </Typography>
            </MenuItem>
          )}
        </Select>
      </div>
    </div>
  )
}

export default SortSelect
